import React from 'react';

const Container = ({ children, className, noPadding = false }) => (
  <div className={`w-full md:w-10/12 ${noPadding ? 'px-0' : 'px-6 md:px-0'} mx-auto ${className}`}>
    {children}
  </div>
)

export default Container;
